import React, { useState } from 'react'
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import successToast from '../toasts/successToast';
import errorToast from '../toasts/errorToast';
import { googleClientId } from '../../redux/config';
import { Spinner } from 'react-bootstrap';
import { googleLoginAction } from '../../redux/actions/authAction';
import { useAuth } from '../../context/AuthContext';

const GoogleLoginButton = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { fetchMe } = useAuth();
    const [loading, setLoading] = useState(false)
    const onSuccess = async (data) => {
        if (data.data.data.requires_2fa) {
            sessionStorage.setItem('2fa_session_token', data.data.data.session_token);
            setLoading(false);
            navigate('/verify-2fa');
            return;
        }
        await fetchMe();
        setLoading(false);
        localStorage.setItem("active_tab", 'Overview');
        successToast(data.data.message);
        navigate('/over-view');
    }
    const onError = (data) => {
        setLoading(false)
        errorToast(data.data.message);
    }
    return (
        <div className='d-flex flex-column justify-content-center align-items-center gap-2'>
            {loading && <div className='d-flex justify-content-center w-100'> <Spinner size='sm' className='text-primary' /> <span className='fs_14 fw_400'>Logging in...</span></div>}
            <GoogleOAuthProvider clientId={googleClientId}>
                <div className=''>
                    <GoogleLogin
                        width={300}
                        text="continue_with"
                        onSuccess={(data) => {
                            dispatch(googleLoginAction({ access_token: data.credential }, onSuccess, onError))
                            setLoading(true)
                        }}
                        onError={() => {
                            errorToast("Login Failed");
                        }}
                    />
                </div>
            </GoogleOAuthProvider>
        </div>
    )
}

export default GoogleLoginButton